// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-pagination__pagination[data-v-4475c8c5]{margin:10px 0;display:flex;justify-content:space-between;align-items:center}.m-pagination__pagination .total[data-v-4475c8c5]{font-size:14px;color:rgba(0,0,0,.6)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
